/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Message/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import MessageTypeIcon from './MessageTypeIcon/index'
import React from 'react'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2EyeFilledIcon from 'DesignSystem/Svgs/Tysiav2EyeFilledIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Message({
  children,
  viewPath = "/App/Account/Topbar/Inbox/Content/Content/Messages/All/Content/Message"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  isHovered
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let messageTitleValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'title',
})
let messageStatusValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'status',
})
let constantData = 'UNREAD'
let aggregateData = fromAggregate.equals(messageStatusValueData, constantData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let messageCreatedAtValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'created_at',
})
let constantData1 = 'ago'
let aggregateData1 = fromHelpers.timeAgo(messageCreatedAtValueData, constantData1)
let messageStatusValueData1 = fromData.useDataValue({ viewPath,
context: 'message',
path: 'status',
})
let constantData2 = 'READ'
let aggregateData2 = fromAggregate.equals(messageStatusValueData1, constantData2)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let messageMessageValueData = fromData.useDataValue({ viewPath,
context: 'message',
path: 'message',
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<button
  data-testid="Message.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--pb-1-Z1Y0bkF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Message.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Message.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Message.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Message.Vertical:1"
  data-view-path={viewPath}
 style={{'--mr-2-Z1Y0bkF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<MessageTypeIcon
  viewPath={`${viewPath}/MessageTypeIcon`}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="semibold"
 data="message.title"
 text={messageTitleValueData}
/>
</div>
<div
  data-testid="Message.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<fromFlow.When is={aggregateData}>
<div
  data-testid="Message.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaButtonIcon
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2EyeFilledIcon
{...childProps}
  viewPath={`${viewPath}/Tysiav2EyeFilledIcon`}
 marginRight={dtSpaceXxs}
 width={12}
 height={12}
 fill2={childProps.isHovered ? dtColorsGreen700 : dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
</div>
</fromFlow.When>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginRight={dtSpaceXxs}
 size="tiny"
 color={dtColorsNeutral400}
 data="message.created_at"
 data="'ago'"
 aggregate="helpers.js timeAgo"
 text={aggregateData1}
/>
<div
  data-testid="Message.Vertical:3"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Y0bkF': aggregateData2 ? dtColorsWhite : dtColorsGreen700}}
 className={`views-block ${styles.Vertical3}`}
/>
</div>
</div>
<div
  data-testid="Message.Vertical:4"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Y0bkF': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs}}
 className={`views-block ${styles.Vertical4}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 whiteSpace="wrap"
 data="message.message"
 text={messageMessageValueData}
/>
</div>
</div>
</button>
{children}
</React.Fragment>)
}